import { Component, OnInit } from '@angular/core';
import { KycService } from '../kyc.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-kyc-pdf',
  templateUrl: './kyc-pdf.component.html',
  styleUrls: ['./kyc-pdf.component.css']
})
export class KycPdfComponent implements OnInit {
  public businessInfo:any
  public businessData : any  = []
  public nuser : any = []
  constructor(private __service:KycService, private router:Router) { }

  ngOnInit() {
    this.getKycData()
  }

  public getKycData(){
    this.__service.getKYCdata().subscribe(res=>{
      console.log("kyc data",res)
      this.nuser = res.data[0].iduser
      this.businessInfo = res.data;
      this.businessInfo.forEach(item => {
        this.businessData[item.key] = item.value;
      });

    })
  }

  public onGoPage(){
    this.router.navigate(['/kyc/kyc'], {
      queryParams: {
        id: this.nuser,
      }
    });
  }

}
